import { render, staticRenderFns } from "./CTA.vue?vue&type=template&id=67774dbf&scoped=true&"
import script from "./CTA.vue?vue&type=script&lang=js&"
export * from "./CTA.vue?vue&type=script&lang=js&"
import style0 from "./CTA.vue?vue&type=style&index=0&id=67774dbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67774dbf",
  null
  
)

export default component.exports